import { ChatFeature } from './chat.feature';
import { CSSProperties, useMemo, useRef } from 'react';
import { IChannelApi, IChatApiMessage, IChatMessage } from '@vivli/features/chat/infrastructure/interface';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { first } from 'rxjs/operators';
import { ChatDataPackageFeature } from '@vivli/shared/features/data-package/feature';

interface ChannelDisplayComponentProps {
    channelId: string;
    isActive: boolean;
    onMessageReceived: (message: IChatApiMessage) => any;
}

export const ChannelDisplayFeature = ({ channelId, isActive, onMessageReceived }: ChannelDisplayComponentProps) => {
    const channelRef = useRef<IChannelApi>();
    const { user: activeUser } = useActiveUserContext();

    const handleFileMessage = (text: string) => {
        if (!channelRef.current) {
            return;
        }

        const message: IChatMessage = {
            text,
            userId: activeUser.userId,
            sent: new Date().toString(),
            systemMessage: true,
        };

        channelRef.current.send(message, true).pipe(first()).subscribe();
    };

    const chatStyle = useMemo<CSSProperties>(() => {
        return {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            columnGap: '10px',
            width: '100%',
            visibility: isActive ? 'visible' : 'hidden',
            justifyContent: 'space-between',
            position: 'absolute',
            zIndex: isActive ? 1 : 0,
            height: isActive ? 'initial' : 0,
            overflow: isActive ? 'visible' : 'hidden',
        };
    }, [isActive]);

    return (
        <div key={channelId} style={chatStyle}>
            <div>
                <ChatFeature
                    channelId={isActive ? channelId : null}
                    onStart={(channel) => (channelRef.current = channel)}
                    onMessageReceived={onMessageReceived}
                    connectOnFirstSend={false}
                />
            </div>
            <div>
                <ChatDataPackageFeature
                    chatChannelId={channelId}
                    allowUpload={true}
                    showFileWarning={true}
                    showChatUploadFileWarning={true}
                    onFileAdded={({ name }) => handleFileMessage(`File Uploaded: ${name}`)}
                    onFileRemoved={({ name }) => handleFileMessage(`File Deleted: ${name}`)}
                />
            </div>
        </div>
    );
};
